export default __webpack_public_path__ + "static/media/forestaliaLogo.e53f135f.png";